import React from "react";
import { Box, Skeleton } from "@mui/material";

interface MyNewsLoadingComponentProps {
  isMobile: boolean;
  loading?: boolean;
}

export const MyNewsLoadingComponent: React.FC<MyNewsLoadingComponentProps> = ({
  isMobile,
  loading = true,
}) => {
  if (!loading) return null;

  return (
    <Box
      padding="16px"
      style={{
        backgroundColor: "#ffffff",
        borderRadius: "4px",
      }}
    >
      <Box
        display="flex"
        flexDirection={isMobile ? "column" : "row"}
        alignItems={isMobile ? "flex-start" : "center"}
        justifyContent="space-between"
      >
        <Skeleton animation="wave" variant="circular" height={49} width={49} />
        <Box
          display="flex"
          width="100%"
          flexDirection="column"
          padding="0px 16px"
        >
          <Skeleton
            variant="text"
            animation="wave"
            height={34}
            width="100%"
            style={{
              marginBottom: "-5px",
            }}
          />
          <Skeleton variant="text" animation="wave" height={34} width="100%" />
        </Box>
      </Box>
      <Skeleton
        variant="text"
        animation="wave"
        height={100}
        width="100%"
        style={{
          marginBottom: "-10px",
        }}
      />
    </Box>
  );
};

export default MyNewsLoadingComponent;
